/**
 * DesktopOnly — the app is desktop-only in v1 (≥1280px). Below 768px it shows
 * this notice, not a degraded layout (CLAUDE.md §5, style guide §5.2, NFR-008).
 *
 * Wrap the app shell with it; the public site stacks instead and does not use it.
 */
import { useSyncExternalStore, type ReactNode } from 'react'

export const SMALL_SCREEN_QUERY = '(max-width: 767px)'

function mediaQuery(): MediaQueryList | null {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(SMALL_SCREEN_QUERY)
    : null
}

function subscribe(onChange: () => void): () => void {
  const mql = mediaQuery()
  if (!mql) return () => undefined
  mql.addEventListener('change', onChange)
  return () => mql.removeEventListener('change', onChange)
}

function getSnapshot(): boolean {
  return mediaQuery()?.matches ?? false
}

function getServerSnapshot(): boolean {
  return false
}

export function DesktopOnly({ children }: { children: ReactNode }) {
  const small = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
  if (!small) return <>{children}</>

  return (
    <main className="mx-auto flex min-h-screen max-w-[560px] flex-col justify-center px-6 py-16">
      <p className="text-overline uppercase text-navy-600">Trellis · by Bloom Credit</p>
      <h1 className="mt-3 text-h2 text-navy-950">Trellis is designed for desktop browsers</h1>
      <p className="mt-3 text-body text-navy-700">
        This app needs a window at least 1280 px wide. Open it on a desktop computer to continue;
        nothing here has been lost.
      </p>
    </main>
  )
}
